import React, { FC } from 'react';
import styles from './Overlay.module.scss';
// import Image from 'next/image';
import CircleCheck from '../../../../../assets/icons/circle-check.svg';
import CloseIcon from '../../../../../assets/icons/close.svg';
import BackArrow from '../../../../../assets/icons/back-arrow.svg';
import { Image } from '@sitecore-jss/sitecore-jss-react';

// type SearchSectionProps = {
//   onBack: () => void;
//   onStart: () => void;
// };

const ThankYouSection = ({ onBack, onStart }) => {
  return (
    <div className={styles.thankYouSection}>
      <button className={styles.closeButton} onClick={onStart}>
        <Image src={CloseIcon} alt="Close" />
      </button>
      <button className={styles.backButton} onClick={onBack} type="button">
        <Image src={BackArrow} alt="Back" />
      </button>
      <div className={styles.circleCheck}>
        <Image src={CircleCheck} alt="CircleCheck" />
      </div>
      <h1>Thank you!</h1>
      <p>
        Thank you for contacting Jaecoo. A dedicated representative will be assisting you shortly.
        We value your time and appreciate your patience.
      </p>
      <button className={styles.acceptButton} onClick={() => onStart()} type="submit">
        OKAY
      </button>
    </div>
  );
};

export default ThankYouSection;
